module.exports = __webpack_public_path__ + "img/2016-05-28.f94469ea.jpg";